// extracted by mini-css-extract-plugin
export default {"canvasContainer":"Editor_canvasContainer__edsTM"};